var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDockerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 2v46H54v23H35.58l-.206 2c-1.15 12.53 1.036 24.088 6.063 33.97l1.688 3.03c1 1.817 2.2 3.523 3.438 5.188s1.686 2.583 2.47 3.688C62.32 133.8 82.13 141 105 141c50.648 0 93.633-22.438 112.656-72.844C231.153 69.54 244.1 66.08 250 54.563c-9.4-5.424-21.478-3.685-28.437-.187L240 2l-72 46h-23V2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.679423 0 0 .679423 -2.086149 13.781817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.305-3.553h4.222V.763h2.135a9.26 9.26 0 0 0 2.934-.492c.46-.156.974-.372 1.426-.644-.596-.778-.9-1.76-1-2.73-.122-1.317.144-3.032 1.036-4.063l.444-.513.53.425c1.332 1.07 2.452 2.565 2.65 4.27 1.603-.472 3.486-.36 4.9.456l.58.335-.305.596c-1.187 2.33-3.687 3.053-6.13 2.925-3.656 9.105-11.615 13.416-21.265 13.416-4.986 0-9.56-1.864-12.164-6.287-.153-.275-.283-.562-.422-.844-.88-1.947-1.173-4.08-.975-6.2l.06-.638h3.6V-3.55h4.222v-4.222h8.445v-4.222h5.067v8.445",
    fill: "#394d54"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.184659 0 0 .184659 3.070472 -11.997864)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.86 3.8h19.818v19.817H123.86z",
    fill: "#00acd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.86 26.676h19.818v19.818H123.86z",
    fill: "#20c2ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M126.292 21.977V5.46m2.972 16.516V5.46m3.002 16.516V5.46m3.003 16.516V5.46m3.003 16.516V5.46m2.97 16.516V5.46",
    stroke: "#394d54",
    strokeWidth: 1.56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    y: 22.866
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    transform: "matrix(1 0 0 -1 22.866 4.572651)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: -91.464,
    y: 45.732
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: -45.732,
    y: 45.732
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 45.732
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.57 54.38c1.533-11.915-7.384-21.275-12.914-25.718-6.373 7.368-7.363 26.678 2.635 34.807-5.58 4.956-17.337 9.448-29.376 9.448H34C32.83 85.484 34 146 34 146h217l-.987-91.424c-9.4-5.424-21.484-3.694-28.443-.197",
    fill: "#17b5eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 89v57h217V89",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.237 140.9c-13.54-6.425-20.972-15.16-25.107-24.694L45 118l21 28 45.237-5.1",
    fill: "#d4edf1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5 53.938v.03c-20.86 26.9-50.783 50.38-82.906 62.72-28.655 11.008-53.638 11.06-70.875 2.22-1.856-1.048-3.676-2.212-5.5-3.312-12.637-8.832-19.754-23.44-19.156-42.687H34V146h217V50h-25z",
    fillOpacity: 0.085
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.496 9.613c2.616.143 5.407.17 7.842-.594",
    fill: "none",
    stroke: "#394d54",
    strokeWidth: 0.628,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.937 7.753a1.01 1.01 0 0 1-1.009 1.009 1.01 1.01 0 0 1-1.01-1.009 1.01 1.01 0 0 1 1.01-1.01 1.01 1.01 0 0 1 1.009 1.01z",
    fill: "#d4edf1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 7.08c-.088.05-.148.146-.148.256 0 .163.132.295.295.295.112 0 .2-.062.26-.154a.73.73 0 0 1 .055.277c0 .4-.324.723-.723.723s-.723-.324-.723-.723.324-.723.723-.723a.72.72 0 0 1 .262.049zM3.07 4.65h46.964c-1.023-.26-3.235-.6-2.87-1.95-1.86 2.152-6.344 1.5-7.475.448-1.26 1.828-8.597 1.133-9.108-.3-1.58 1.854-6.475 1.854-8.055 0-.512 1.424-7.848 2.12-9.1.3C12.284 4.2 7.8 4.853 5.94 2.7c.365 1.34-1.848 1.7-2.87 1.95",
    fill: "#394d54"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerIcon);
export default __webpack_public_path__ + "static/media/docker-icon.5acac4b4a9268616752dd9c3d466a35e.svg";
export { ForwardRef as ReactComponent };